import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import useNavAction from 'hooks/actions/useNavAction';
import FocusableButton from 'components/common/FocusableButton';
import React from 'react';

export default function AdvidceNavButton(props) {
  const {
    triggered,
    onTrigger,
  } = useNavAction('Advice', props);

  return (
    <FocusableButton {...ex(['NavButton', 'AdviceNavButton', { triggered }], props)} {...{ onClick: onTrigger() }}>
      {T('인슐린 투여 권고 이력')}
    </FocusableButton>
  );
}
